import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';

// pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import Services from './pages/Services';
import About from './pages/About';
import Portefolio from './pages/Portefolio';
import {useDocTitle} from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';
import NotFound from './pages/NotFound';
import { ProjectModalProvider } from './components/ProjectModal/ProjectModalContext';


function App() {
  useEffect(() => {
    AOS.init({
      once: true,
      duration: 700,
      offset: 60,
      easing: 'ease-out-cubic',
    });
    AOS.refresh();
  }, []);

  useDocTitle("kesnelDigital · Web & mobile software studio");

  return (
    <>
      <Router>
        <ProjectModalProvider>
          <ScrollToTop>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/portefolio" element={<Portefolio />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </ScrollToTop>
        </ProjectModalProvider>
      </Router>
    </>
  );
}


export default App;
